import { useMutation } from '@tanstack/react-query';
import { useBoundStore } from '@Store/index.ts';
import { createPartnerLead, ICreateLeadPayload } from '@Services/init/partnerWelcome.api.ts';
import {
  identifyTrackingServiceUser,
  setPeopleProperty,
} from '@Services/analytics/tracking.service.ts';
import { LiliPlanType } from '@Pages/happyFlowPages/planSelection/types.ts';
import { setHotJarPeopleData } from '@Services/analytics/hotjar.service.ts';
import { getFlowId } from '@Services/analytics/analytics.service.ts';
import { useWelcomeAnalytics } from '@Pages/passwordless/welcome/WelcomeAnalytics.tsx';

export const useCreatePartnerLead = () => {
  const customerData = useBoundStore((state) => state.customer);
  const { isFromLiliApp } = useBoundStore((state) => state.onboardingSlice);
  const setCustomerData = useBoundStore((state) => state.setCustomerData);
  const { reportStartOnboarding } = useWelcomeAnalytics();

  return useMutation({
    mutationFn: (props: ICreateLeadPayload) => createPartnerLead({ ...props }),
    onSuccess: (data) => {
      identifyTrackingServiceUser(data.externalId);
      reportStartOnboarding();
      const analyticsProps = {
        canSelectPlan: true,
        isFromLiliApp,
        defaultPlanSelected: LiliPlanType.SMART, // @TODO: check with Nir.
        flowId: getFlowId(),
        isReactProject: true,
      };
      setPeopleProperty(analyticsProps);
      setHotJarPeopleData(data.externalId, analyticsProps);
      const updatedCustomerData = { ...customerData, ...data };
      setCustomerData(updatedCustomerData);
    },
  });
};
